import type { ImportantKpiEntry } from '@app/src/pages/Configurations/ConfigurationsPages/Automation/CreationSteps/HighlightImportantKpis/types'

export enum BulkCreateExpectationFormField {
  AssessmentTemplateId = 'assessmentTemplateId',
  TargetAssessmentLevel = 'targetAssessmentLevel',
  ProviderIds = 'providerIds',
  Deadline = 'deadline',
  ImportantKpis = 'importantKpis',
}

export type BulkCreateExpectationFormData = {
  [BulkCreateExpectationFormField.AssessmentTemplateId]: number | null
  [BulkCreateExpectationFormField.TargetAssessmentLevel]: number
  [BulkCreateExpectationFormField.ProviderIds]: number[]
  [BulkCreateExpectationFormField.Deadline]: string | null
  [BulkCreateExpectationFormField.ImportantKpis]: ImportantKpiEntry[]
}

export type BulkCreateExpectationSubmissionPayload = {
  assessmentTemplateId: number
  targetAssessmentLevel: number
  providerIds: number[]
  deadline: string
  importantQuestions?: ImportantKpiEntry[]
}
